import { useEffect, useState } from "react";
import useApi from "../function/useApi";
import { Flex, Text, VStack,FormatNumber, Stat, Separator, HStack, Link, useBreakpointValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { userContextAction } from "../store/UserContext";
import { useOutletContext } from "react-router";

const Units = ()=>{
    const { responses, loading, error, fetchData } = useApi();
    const [machines, setMachines] = useState([]);
    const dispatch = useDispatch();
    const user = useSelector(u=>u.userContext.user);

    useEffect(()=>{
        fetchData('machines',`${process.env.REACT_APP_API_URL}?data=machine`);
    },[]);

    useEffect(()=>{
        if(loading?.machines){
            dispatch(userContextAction.loadingOn())
        }else{
            dispatch(userContextAction.loadingOff())
        }
    },[loading?.machines]);

    useEffect(()=>{
        if(responses?.machines){
            const newMachines = responses.machines.sort((a, b) => a.local_name.localeCompare(b.local_name));
            setMachines(newMachines);
        }
    },[responses?.machines]);

    return (
        <Flex padding={'10vh 20vw'} width={'100%'} height={"100%"}  justifyContent={'center'} flexDir={'column'} gap="10px" >
            <Text  textStyle="3xl" fontWeight={'bold'}>Unit</Text>
            <br></br>
            <br></br>
                    <Flex  width={'100%'} height={"100%"} flexDir={'column'} gap={'10px'}>
                        
                        {machines.map((u, index)=>{
                            return (<div><MachineItem machine={u} key={u.id}/>  <br/> <Separator size="md"/><br/> </div>)
                        })}
                        
                    </Flex>
                </Flex>
    );
}

export default Units;


const MachineItem = ({machine}) =>{
const StackComponent = useBreakpointValue({ base: VStack, xl: HStack });
    return (
        <VStack alignItems={'flex-start'}>
        <StackComponent gap={{base:'5', md:'30'}}  width="100%" alignItems={'baseline'}>
            <Link textStyle={{base:"xl",md:"3xl",}} href={`/home/unit/${machine.id}`}>{machine.local_name}</Link>
                
                <Text fontWeight="light" textStyle={'xs'}>{machine.lastUpdate}</Text>
                </StackComponent>
             <VStack gap={'2'} alignItems={'flex-start'}>
            {/* <Text >Nama Unit: {machine.name}</Text> */}
            
            <Text>{machine.rent}</Text>
            <Stat.Root>
                <Stat.Label>HM Saat Ini</Stat.Label>
                <Stat.ValueText>
                    {machine.total_hour}
                </Stat.ValueText>
                </Stat.Root>
            </VStack>   
    
        </VStack>
    )
}